import { render, staticRenderFns } from "./RootFooter.vue?vue&type=template&id=d7837caa&scoped=true&"
import script from "./RootFooter.vue?vue&type=script&lang=js&"
export * from "./RootFooter.vue?vue&type=script&lang=js&"
import style0 from "./RootFooter.vue?vue&type=style&index=0&id=d7837caa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7837caa",
  null
  
)

export default component.exports